<lib-general-condition [labels]="'lib.generalCondition' | translate" bank="WUnivers" [bigTitle]="bigTitle | translate" [description]="description" [conditions]="conditions"
  [contactEmail]="contactEmail" [infoEmail]="infoEmail" [website]="website"></lib-general-condition>
